import { ref } from "vue";
import { locale } from "../locale";

interface ModalConfig {
	id: string;
	title: string;
	text: string;
	controls: {
		left: ModalControl[];
		right: ModalControl[];
	};
}

interface ModalControl {
	type: string;
	color: "red" | "blue";
	text: string;
	fn: () => void;
}

export const activeModal = ref<ModalConfig | null>(null);

export function closeModal() {
	activeModal.value = null;
}

function setModal(config: ModalConfig) {
	activeModal.value = config;
}

interface InformationModalConfig {
	text: string;
	title: string;
}

export function InformationModal(config: InformationModalConfig) {
	setModal({
		id: `information-modal`,
		title: config.title,
		text: config.text,
		controls: {
			left: [],
			right: [
				{
					type: "submit",
					text: locale.modalButtons.ok,
					color: "blue",
					fn: closeModal,
				},
			],
		},
	});
}

export function ClearChatModal(fn: () => unknown) {
	setModal({
		id: `clear-chat-modal`,
		title: locale.chat.clearChatTitle,
		text: locale.chat.clearChatDescr,
		controls: {
			left: [],
			right: [
				{
					type: "submit",
					text: locale.modalButtons.back,
					color: "blue",
					fn: closeModal,
				},
				{
					type: "submit",
					text: locale.chat.clearBtn,
					color: "blue",
					fn,
				},
			],
		},
	});
}

export function endCallModal(end: () => unknown, leave: () => unknown) {
	setModal({
		id: `end-call-modal`,
		title: locale.endCallModal.title,
		text: locale.endCallModal.text,
		controls: {
			left: [
				{
					type: "cancel",
					text: locale.endCallModal.back.toUpperCase(),
					color: "blue",
					fn: closeModal,
				},
			],
			right: [
				{
					type: "submit",
					text: locale.endCallModal.end,
					color: "red",
					fn: end,
				},
				{
					type: "submit",
					text: locale.endCallModal.leave,
					color: "blue",
					fn: leave,
				},
			],
		},
	});
}

export function removeAccModal(ok: () => unknown) {
	setModal({
		id: `remove-Acc-modal`,
		title: "Удалить аккаунт?",
		text: "Это действие необратимое. Вы уверены?",
		controls: {
			left: [
				{
					type: "cancel",
					text: "ОТМЕНА",
					color: "blue",
					fn: closeModal,
				},
			],
			right: [
				{
					type: "submit",
					text: "УДАЛИТЬ",
					color: "red",
					fn: ok,
				},
			],
		},
	});
}

export function confirmModal(data: {
	title: string;
	text: string;
	ok: () => unknown;
	okBtn: {
		text: string;
		color: "red" | "blue";
	};
}) {
	setModal({
		id: `confirm-modal`,
		title: data.title,
		text: data.text,
		controls: {
			left: [
				{
					type: "cancel",
					text: "ОТМЕНА",
					color: "blue",
					fn: closeModal,
				},
			],
			right: [
				{
					type: "submit",
					text: data.okBtn.text,
					color: data.okBtn.color,
					fn: data.ok,
				},
			],
		},
	});
}
